var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var isObject = require('../help/is_object');

var secs = require('../help/secs');

var epoch = require('../help/epoch');

var getKey = require('../help/get_key');

var JWS = require('../jws');

var isString = require('./shared_validations').isString.bind(undefined, TypeError);

var validateOptions = function validateOptions(options) {
  if (typeof options.iat !== 'boolean') {
    throw new TypeError('options.iat must be a boolean');
  }

  if (typeof options.kid !== 'boolean') {
    throw new TypeError('options.kid must be a boolean');
  }

  isString(options.subject, 'options.subject');
  isString(options.issuer, 'options.issuer');

  if (options.audience !== undefined && (typeof options.audience !== 'string' || !options.audience) && (!Array.isArray(options.audience) || options.audience.length === 0 || options.audience.some(function (a) {
    return !a || typeof a !== 'string';
  }))) {
    throw new TypeError('options.audience must be a string or an array of strings');
  }

  if (!isObject(options.header)) {
    throw new TypeError('options.header must be an object');
  }

  isString(options.algorithm, 'options.algorithm');
  isString(options.expiresIn, 'options.expiresIn');
  isString(options.notBefore, 'options.notBefore');
  isString(options.jti, 'options.jti');

  if (options.now !== undefined && (!(options.now instanceof Date) || !options.now.getTime())) {
    throw new TypeError('options.now must be a valid Date object');
  }
};

module.exports = function (payload, key) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!isObject(options)) {
    throw new TypeError('options must be an object');
  }

  var algorithm = options.algorithm,
      audience = options.audience,
      expiresIn = options.expiresIn,
      _options$header = options.header,
      header = _options$header === void 0 ? {} : _options$header,
      _options$iat = options.iat,
      iat = _options$iat === void 0 ? true : _options$iat,
      issuer = options.issuer,
      jti = options.jti,
      _options$kid = options.kid,
      kid = _options$kid === void 0 ? true : _options$kid,
      notBefore = options.notBefore,
      subject = options.subject,
      now = options.now;
  validateOptions({
    algorithm: algorithm,
    audience: audience,
    expiresIn: expiresIn,
    header: header,
    iat: iat,
    issuer: issuer,
    jti: jti,
    kid: kid,
    notBefore: notBefore,
    now: now,
    subject: subject
  });

  if (!isObject(payload)) {
    throw new TypeError('payload must be an object');
  }

  var unix;

  if (expiresIn || notBefore || iat) {
    unix = epoch(now || new Date());
  }

  payload = _objectSpread({}, payload, {
    sub: subject || payload.sub,
    aud: audience || payload.aud,
    iss: issuer || payload.iss,
    jti: jti || payload.jti,
    iat: iat ? unix : payload.iat,
    exp: expiresIn ? unix + secs(expiresIn) : payload.exp,
    nbf: notBefore ? unix + secs(notBefore) : payload.nbf
  });
  key = getKey(key);
  var includeKid;

  if (typeof options.kid === 'boolean') {
    includeKid = kid;
  } else {
    includeKid = !key.secret;
  }

  return JWS.sign(JSON.stringify(payload), key, _objectSpread({}, header, {
    alg: algorithm || header.alg,
    kid: includeKid ? key.kid : header.kid
  }));
};